module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product17-627705381911c293d92c907553a46a32.jpg";